/**
 * Normalize and construct the CMS API base URL
 */
export function getCmsApiBaseUrl(): string {
  let baseUrl =
    process.env.EXPO_PUBLIC_CMS_API_BASE_URL || "https://cms.louise.life";
  baseUrl = baseUrl.replace(/\/+$/, "");
  if (!baseUrl.endsWith("/api")) {
    baseUrl = `${baseUrl}/api`;
  }
  return baseUrl;
}
